
<div class="row">
    <div class="col-md-12">

        <div class="card card-accent-success animated fadeIn container-filter">

            <a class="card-header-a" (click)="isCollapsedDatosNumSeguridad = !isCollapsedDatosNumSeguridad" [attr.aria-expanded]="!isCollapsedDatosNumSeguridad" aria-controls="collapseExample">
                <div class="card-header-buscador">
                    <i class="fa fa-file-text-o"></i> Números Seguridad
                    <i *ngIf="isCollapsedDatosNumSeguridad" class="fa fa-caret-down float-right"></i>
                    <i *ngIf="!isCollapsedDatosNumSeguridad" class="fa fa-caret-up float-right"></i>
                </div>
            </a>

            <div class="card-body-detalle">

                <div class="collapse group-filtros-cf" id="collapsedDatosNumSeguridad" [ngbCollapse]="isCollapsedDatosNumSeguridad">

                    <label class="col-form-label">
                        <i class="fa fa-align-justify"></i> Listado de Números de Seguridad
                    </label>


                    <p-table #tableSearch autoLayout="true" [value]="resultNumeroSeguridad.ResultList" [lazy]="true"
                             (onLazyLoad)="onSearchLazy($event)" [paginator]="true"
                             [columns]="cols" sortField="NumeroCertificado" [rows]="resultNumeroSeguridad?.PageSize" [totalRecords]="resultNumeroSeguridad.TotalCount"
                             [loading]="loading"
                             styleClass="table table-responsive-sm  table-striped table-sm"
                             [ngClass]="displayGridHidden(resultNumeroSeguridad.ResultList)">

                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                    {{col.header}}
                                    <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                            <tr>
                                <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                    <span *ngIf="col.field!=='Link'">{{rowData[col.field]}}</span>

                                    <div *ngIf="col.field==='Link' && tieneUsuarioPermisosEdicion" class="btn-group">
                                        <button (click)="onEditNumeroSeguridad(rowData)" type="button"
                                                class="btn btn-sm btn-warning">
                                            <span class="fa fa-edit"></span>

                                        </button>
                                    </div>

                                    <div *ngIf="col.field==='Link' && tieneUsuarioPermisosEdicion" class="btn-group">
                                        <button (click)="onDeleteNumeroSeguridad(rowData)" type="button"
                                                class="btn btn-sm btn-danger">
                                            <span class="fa fa-remove"></span>

                                        </button>
                                    </div>
                                </td>
                            </tr>

                        </ng-template>
                    </p-table>
                    <div *ngIf="tableSearch.totalRecords">Se han encontrado {{tableSearch.totalRecords}} registros</div>
                    <div class="empty-grid" *ngIf="tableSearch.totalRecords==0">No se ha encontrado ningún número de seguridad</div>


                </div>
            </div>
        </div>
    </div>
</div>
